import { AssignmentTurnedIn as AssignmentTurnedInIcon } from "@mui/icons-material";
import { FC, ReactElement } from "react";

import { Grid } from "@mui/material";
import StyledFab from "./StyledFab";

interface ConfirmationFabProps {
  child?: ReactElement;
  onClick: () => void;
  disabled: boolean;
}

const ConfirmationFab: FC<ConfirmationFabProps> = (props) => {
  const { child, onClick, disabled } = props;
  return (
    <Grid
      container
      direction="column"
      width="inherit"
      alignItems="flex-end"
      sx={{
        position: "fixed",
        bottom: 0,
        right: 0,
      }}
    >
      <Grid item>
        <StyledFab disabled={disabled} onClick={onClick}>
          {child ? child : <AssignmentTurnedInIcon />}
        </StyledFab>
      </Grid>
    </Grid>
  );
};

export default ConfirmationFab;
